"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  StyleOnePinCircleAdd: ['style-one-pin-circle-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,15.5a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,15.5Z', 'M14.5,8.25h-1A.25.25,0,0,1,13.25,8V7a1.25,1.25,0,0,0-2.5,0V8a.25.25,0,0,1-.25.25h-1a1.25,1.25,0,0,0,0,2.5h1a.25.25,0,0,1,.25.25v1a1.25,1.25,0,0,0,2.5,0V11a.25.25,0,0,1,.25-.25h1a1.25,1.25,0,0,0,0-2.5Z']],
  StyleOnePinCircleMinus: ['style-one-pin-circle-minus', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,15.5a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,15.5Z', 'M14.5,8.25h-5a1.25,1.25,0,0,0,0,2.5h5a1.25,1.25,0,0,0,0-2.5Z']],
  StyleOnePinHome: ['style-one-pin-home', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm6.823,8.618A.5.5,0,0,1,18.5,9.5H17.25a.25.25,0,0,0-.25.25V14.5a.5.5,0,0,1-.5.5H14a.5.5,0,0,1-.5-.5V12.25a1.5,1.5,0,0,0-3,0V14.5a.5.5,0,0,1-.5.5H7.5a.5.5,0,0,1-.5-.5V9.75a.25.25,0,0,0-.25-.25H5.5a.5.5,0,0,1-.324-.882l6.5-5.5a.5.5,0,0,1,.647,0Z']],
  StyleOnePinWifi: ['style-one-pin-wifi', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,15.5a1.75,1.75,0,1,1,1.75-1.75A1.752,1.752,0,0,1,12,15.5Zm4.278-4.634a1,1,0,0,1-1.406.151,4.538,4.538,0,0,0-5.744,0A1,1,0,0,1,7.872,9.46a6.526,6.526,0,0,1,8.256,0A1,1,0,0,1,16.278,10.866ZM18,8.123a1,1,0,0,1-.628-.222,8.493,8.493,0,0,0-10.744,0A1,1,0,0,1,5.372,6.344a10.481,10.481,0,0,1,13.256,0A1,1,0,0,1,18,8.123Z']],
  StyleOnePinBolt: ['style-one-pin-bolt', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm4.477,9.47L10.7,16.657a.252.252,0,0,1-.2.093.263.263,0,0,1-.083-.014.251.251,0,0,1-.167-.236V11a.25.25,0,0,0-.25-.25H8.108a.751.751,0,0,1-.585-1.22l5.782-7.187a.25.25,0,0,1,.445.157V8a.25.25,0,0,0,.25.25h1.892a.751.751,0,0,1,.585,1.22Z']],
  StyleOnePinBook: ['style-one-pin-book', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm-.5,14.283a.5.5,0,0,1-.5.5.492.492,0,0,1-.224-.053l-4-2a.5.5,0,0,1-.276-.447v-6a.5.5,0,0,1,.724-.447l4,2a.5.5,0,0,1,.276.447Zm.5-7.5a.492.492,0,0,1-.224-.053L8.209,4.947a.5.5,0,0,1,.448-.894L12,5.725l3.343-1.672a.5.5,0,1,1,.448.894L12.224,6.73A.492.492,0,0,1,12,6.783Zm5.5,5.5a.5.5,0,0,1-.276.447l-4,2a.492.492,0,0,1-.224.053.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.276-.447l4-2a.5.5,0,0,1,.724.447Z']],
  StyleOnePinCar: ['style-one-pin-car', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0ZM8,7a2.5,2.5,0,0,1,2.5-2.5h3A2.5,2.5,0,0,1,16,7a.5.5,0,0,1-.5.5h-7A.5.5,0,0,1,8,7Zm8.61,5.152a.252.252,0,0,0-.11.208v.89a.75.75,0,0,1-1.5,0v-.5a.25.25,0,0,0-.25-.25H9.25a.25.25,0,0,0-.25.25v.5a.75.75,0,0,1-1.5,0v-.89a.253.253,0,0,0-.111-.208,2.014,2.014,0,0,1-.688-.793A.25.25,0,0,1,6.926,11H8.5a.5.5,0,0,0,0-1H6.927A.25.25,0,0,1,6.7,9.643,1.994,1.994,0,0,1,8.5,8.5h7a2,2,0,0,1,1.8,1.142.251.251,0,0,1-.226.358H15.5a.5.5,0,0,0,0,1h1.574a.25.25,0,0,1,.225.359A2.009,2.009,0,0,1,16.61,12.152Z']],
  StyleOnePinCart: ['style-one-pin-cart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0ZM9,15.5a1,1,0,1,1,1-1A1,1,0,0,1,9,15.5Zm4.5,0a1,1,0,1,1,1-1A1,1,0,0,1,13.5,15.5Zm.979-3.356A.5.5,0,0,1,14,12.5H8.5a.5.5,0,0,1-.472-.335l-1.75-5A.5.5,0,0,1,6.75,6.5h7.671a.25.25,0,0,0,.24-.178l.8-2.666a.75.75,0,1,1,1.437.431Z']],
  StyleOnePinCheck: ['style-one-pin-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,15.5a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,15.5Z', 'M13.874,7.155l-2.559,3.412a.249.249,0,0,1-.377.027L9.844,9.5A1,1,0,0,0,8.43,10.914l1.5,1.5a1.743,1.743,0,0,0,1.235.517c.042,0,.084,0,.127,0a1.742,1.742,0,0,0,1.278-.7l2.9-3.875a1,1,0,0,0-1.6-1.2Z']],
  StyleOnePinChurch: ['style-one-pin-church', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm5.781,10.087A.5.5,0,0,1,17.5,11h-1a.5.5,0,0,0-.5.5V15a.5.5,0,0,1-.5.5H14a.5.5,0,0,1-.5-.5V13a1.5,1.5,0,0,0-3,0v2a.5.5,0,0,1-.5.5H8.5A.5.5,0,0,1,8,15V11.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.281-.913l4.813-3.282a.5.5,0,0,0,.218-.413V6a.5.5,0,0,0-.5-.5h-.5a.75.75,0,0,1,0-1.5h.5a.5.5,0,0,0,.5-.5V3a.75.75,0,0,1,1.5,0v.5a.5.5,0,0,0,.5.5h.5a.75.75,0,0,1,0,1.5h-.5a.5.5,0,0,0-.5.5v.392a.5.5,0,0,0,.218.413Z']],
  StyleOnePin: ['style-one-pin', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,15.75A6.25,6.25,0,1,1,18.25,9.5,6.257,6.257,0,0,1,12,15.75Z', 'M7.750 9.500 A4.250 4.250 0 1 0 16.250 9.500 A4.250 4.250 0 1 0 7.750 9.500 Z']],
  StyleOnePinDollar: ['style-one-pin-dollar', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,15.5a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,15.5Z', 'M14.875,11.158A2.33,2.33,0,0,0,13.4,8.984L11.34,8.159a.342.342,0,0,1,.127-.659H13.5a1,1,0,0,0,0-2h-.25A.25.25,0,0,1,13,5.25a1,1,0,0,0-2,0v.1a.251.251,0,0,1-.181.241,2.341,2.341,0,0,0-.221,4.424l2.062.825a.342.342,0,0,1-.127.659H10.5a1,1,0,0,0,0,2h.25a.25.25,0,0,1,.25.25,1,1,0,0,0,2,0v-.1a.251.251,0,0,1,.181-.241A2.345,2.345,0,0,0,14.875,11.158Z']],
  StyleOnePinDrink: ['style-one-pin-drink', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm3.5,7.5a3.5,3.5,0,0,1-2.406,3.32.5.5,0,0,0-.344.475V12.75a.5.5,0,0,0,.5.5H14a.75.75,0,0,1,0,1.5H10a.75.75,0,0,1,0-1.5h.75a.5.5,0,0,0,.5-.5V11.3a.5.5,0,0,0-.344-.475A3.5,3.5,0,0,1,8.5,7.5v-1A1.5,1.5,0,0,1,10,5h4a1.5,1.5,0,0,1,1.5,1.5Z']],
  StyleOnePinGas: ['style-one-pin-gas', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.5,5.5h-2a.5.5,0,0,0,0,1h2a.5.5,0,0,0,0-1Z', 'M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0ZM7.5,6A1.5,1.5,0,0,1,9,4.5h3A1.5,1.5,0,0,1,13.5,6V7.25a.25.25,0,0,1-.25.25H7.75a.25.25,0,0,1-.25-.25Zm10.416.624-1.055.7a.251.251,0,0,0-.111.208V10.5A2.752,2.752,0,0,1,14,13.25h-.327a.251.251,0,0,0-.24.178A1.5,1.5,0,0,1,12,14.5H9A1.5,1.5,0,0,1,7.5,13V8.75a.25.25,0,0,1,.25-.25h5.5a.25.25,0,0,1,.25.25V11.5a.25.25,0,0,0,.25.25H14a1.252,1.252,0,0,0,1.25-1.25V7.535a1.745,1.745,0,0,1,.779-1.456l1.055-.7a.75.75,0,0,1,.832,1.248Z']],
  StyleOnePinGym: ['style-one-pin-gym', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.818,0l1.875-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm7,10H18a.5.5,0,0,0-.5.5v.75a1.75,1.75,0,0,1-3.5,0V10.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v.75a1.75,1.75,0,0,1-3.5,0V10.5A.5.5,0,0,0,6,10H5A.75.75,0,0,1,5,8.5H6A.5.5,0,0,0,6.5,8V7.25a1.75,1.75,0,0,1,3.5,0V8a.5.5,0,0,0,.5.5h3A.5.5,0,0,0,14,8V7.25a1.75,1.75,0,0,1,3.5,0V8a.5.5,0,0,0,.5.5h1A.75.75,0,0,1,19,10Z']],
  StyleOnePinCross: ['style-one-pin-cross', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm5.5,10.5a1,1,0,0,1-1,1h-2a.5.5,0,0,0-.5.5v2a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1V12a.5.5,0,0,0-.5-.5h-2a1,1,0,0,1-1-1v-2a1,1,0,0,1,1-1h2A.5.5,0,0,0,10,7V5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V7a.5.5,0,0,0,.5.5h2a1,1,0,0,1,1,1Z']],
  StyleOnePinQuestion: ['style-one-pin-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,15.5a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,15.5Z', 'M12,5A2.879,2.879,0,0,0,9.125,7.875a1,1,0,0,0,2,0,.875.875,0,1,1,1.062.855A1.507,1.507,0,0,0,11,10.2v.3a1,1,0,0,0,2,.072A2.875,2.875,0,0,0,12,5Z', 'M10.750 13.250 A1.250 1.250 0 1 0 13.250 13.250 A1.250 1.250 0 1 0 10.750 13.250 Z']],
  StyleOnePinPlane: ['style-one-pin-plane', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm6.757,8.556L9.6,14.244a.561.561,0,0,1-.621-.018L5.616,11.869a.31.31,0,0,1-.047-.437.327.327,0,0,1,.053-.052l1.031-.864a.31.31,0,0,1,.3-.052l1.479.882a.5.5,0,0,0,.554-.028l1.759-1.3a.5.5,0,0,0-.035-.827L7.092,6.947A.385.385,0,0,1,7.048,6.4a.378.378,0,0,1,.062-.058l1.038-.769a.386.386,0,0,1,.364-.052l5.607,2.088a.5.5,0,0,0,.456-.056l2.493-1.7a1.508,1.508,0,0,1,1.187-.228A1.611,1.611,0,0,1,19.41,6.665a1.512,1.512,0,0,1,.09.512A1.594,1.594,0,0,1,18.757,8.556Z']],
  StyleOnePinRestaurant: ['style-one-pin-restaurant', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm.5,7.75a3.248,3.248,0,0,1-2.167,3.056.5.5,0,0,0-.333.471V14.75a.75.75,0,0,1-1.5,0V11.277a.5.5,0,0,0-.333-.471A3.248,3.248,0,0,1,6,7.75v-3a.75.75,0,0,1,1.5,0V8a.5.5,0,0,0,1,0V4.75a.75.75,0,0,1,1.5,0V8a.5.5,0,0,0,1,0V4.75a.75.75,0,0,1,1.5,0Zm2-3a.749.749,0,0,1,1.084-.671C17.813,5.188,18,8.749,18,12a.75.75,0,0,1-.75.75H16.5a.5.5,0,0,0-.5.5v1.5a.75.75,0,0,1-1.5,0Z']],
  StyleOnePinStar: ['style-one-pin-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm4.8,8.2-2.043,2.015a.249.249,0,0,0-.054.277l1.132,2.6a.654.654,0,0,1-.931.819l-2.778-1.565a.249.249,0,0,0-.245,0L9.1,13.912a.654.654,0,0,1-.931-.819l1.132-2.6a.249.249,0,0,0-.054-.277L7.2,8.2a.613.613,0,0,1,.429-1.07H9.968a.25.25,0,0,0,.227-.144l1.217-2.625a.662.662,0,0,1,1.177,0L13.8,6.982a.248.248,0,0,0,.226.145h2.336A.613.613,0,0,1,16.8,8.2Z']],
  StyleOnePinPhotography: ['style-one-pin-photography', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0v0l1.875-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm5.5,11.5A1.5,1.5,0,0,1,16,13H8a1.5,1.5,0,0,1-1.5-1.5v-4A1.5,1.5,0,0,1,8,6h.8a.5.5,0,0,0,.416-.222l.222-.333A1,1,0,0,1,10.268,5h3.464a1,1,0,0,1,.832.445l.222.332A.5.5,0,0,0,15.2,6H16a1.5,1.5,0,0,1,1.5,1.5Z', 'M10.000 9.500 A2.000 2.000 0 1 0 14.000 9.500 A2.000 2.000 0 1 0 10.000 9.500 Z']],
  StyleOnePinTrain1: ['style-one-pin-train_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.614,13.857a.751.751,0,0,1,1.03.257l.827,1.379a.5.5,0,0,0,.813.063,9.5,9.5,0,1,0-14.568,0,.5.5,0,0,0,.813-.063l.827-1.379a.751.751,0,0,1,1.288.772L6.559,16.693a.5.5,0,0,0,.143.668,8.716,8.716,0,0,0,1.3.758,2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118a8.69,8.69,0,0,0,1.3-.757.5.5,0,0,0,.143-.668l-1.085-1.807A.751.751,0,0,1,16.614,13.857ZM15,13H9a1.5,1.5,0,0,1-1.5-1.5v-4a4.5,4.5,0,0,1,9,0v4A1.5,1.5,0,0,1,15,13Z', 'M8.500 11.000 A1.000 1.000 0 1 0 10.500 11.000 A1.000 1.000 0 1 0 8.500 11.000 Z', 'M13.500 11.000 A1.000 1.000 0 1 0 15.500 11.000 A1.000 1.000 0 1 0 13.500 11.000 Z', 'M9.500 7.000 A2.5 2 0 1 0 14.500 7.000 A2.5 2 0 1 0 9.500 7.000 Z']],
  StyleOnePinTunnel: ['style-one-pin-tunnel', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,5a1,1,0,1,1,1-1,1,1,0,0,1-1,1,5.564,5.564,0,0,1,5.5,4.95.494.494,0,0,1-.126.385A.5.5,0,0,1,17,10.5H7a.5.5,0,0,1-.371-.165A.494.494,0,0,1,6.5,9.95,5.564,5.564,0,0,1,12,5Zm6,8H6a.75.75,0,0,1,0-1.5H18A.75.75,0,0,1,18,13Z', 'M9.7,7.728a.5.5,0,0,0,.288-.092A3.476,3.476,0,0,1,12,7a.5.5,0,0,0,0-1,4.467,4.467,0,0,0-2.589.819.5.5,0,0,0,.288.909Z']],
  StyleOnePinWarning: ['style-one-pin-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm5.863,13.552a.948.948,0,0,1-.807.448H6.944a.948.948,0,0,1-.807-.448.923.923,0,0,1-.031-.914L11.162,3a.95.95,0,0,1,1.676,0l5.056,9.635A.923.923,0,0,1,17.863,13.552Z', 'M10.750 11.750 A1.250 1.250 0 1 0 13.250 11.750 A1.250 1.250 0 1 0 10.750 11.750 Z', 'M12,10a1,1,0,0,0,1-1V6a1,1,0,0,0-2,0V9A1,1,0,0,0,12,10Z']],
  StyleOnePinTrain: ['style-one-pin-train', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.500 11.000 A1.000 1.000 0 1 0 10.500 11.000 A1.000 1.000 0 1 0 8.500 11.000 Z', 'M13.500 11.000 A1.000 1.000 0 1 0 15.500 11.000 A1.000 1.000 0 1 0 13.500 11.000 Z', 'M12,0A9.469,9.469,0,0,0,4.716,15.556a.5.5,0,0,0,.813-.063l.827-1.379a.751.751,0,0,1,1.288.772L6.559,16.694a.5.5,0,0,0,.143.667,8.63,8.63,0,0,0,1.3.758,2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118a8.61,8.61,0,0,0,1.3-.758.5.5,0,0,0,.143-.667l-1.085-1.807a.751.751,0,0,1,1.288-.772l.827,1.379a.5.5,0,0,0,.813.063A9.469,9.469,0,0,0,12,0ZM11,1.5h2A.75.75,0,0,1,13,3H11a.75.75,0,0,1,0-1.5Zm-3.5,4A1.5,1.5,0,0,1,9,4h6a1.5,1.5,0,0,1,1.5,1.5v2A.5.5,0,0,1,16,8H8a.5.5,0,0,1-.5-.5Zm9,6A1.5,1.5,0,0,1,15,13H9a1.5,1.5,0,0,1-1.5-1.5v-2A.5.5,0,0,1,8,9h8a.5.5,0,0,1,.5.5Z']],
  StyleOnePinUser: ['style-one-pin-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,2.5a3,3,0,1,1-3,3A3,3,0,0,1,12,2.5Zm4,12H8a.5.5,0,0,1-.5-.5,4.5,4.5,0,0,1,9,0A.5.5,0,0,1,16,14.5Z']],
  StyleOnePinInformation: ['style-one-pin-information', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,15.5a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,15.5Z', 'M10.250 6.000 A1.250 1.250 0 1 0 12.750 6.000 A1.250 1.250 0 1 0 10.250 6.000 Z', 'M14.5,13a1,1,0,0,0-1-1,.5.5,0,0,1-.5-.5v-2A1.5,1.5,0,0,0,11.5,8h-1a1,1,0,0,0,0,2,.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5,1,1,0,0,0,0,2h3A1,1,0,0,0,14.5,13Z']],
  StyleOnePinSkull: ['style-one-pin-skull', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm6,10.5a3,3,0,0,1-2.143,2.875.5.5,0,0,0-.357.479V14.5a1.5,1.5,0,0,1-.749,1.3A.5.5,0,0,1,14,15.366V14a.5.5,0,0,0-1,0v1.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V14a.5.5,0,0,0-1,0v1.366a.5.5,0,0,1-.751.432A1.5,1.5,0,0,1,8.5,14.5v-.646a.5.5,0,0,0-.357-.479A3,3,0,0,1,6,10.5V9A6,6,0,0,1,18,9Z', 'M7.500 9.500 A1.500 1.500 0 1 0 10.500 9.500 A1.500 1.500 0 1 0 7.500 9.500 Z', 'M13.500 9.500 A1.500 1.500 0 1 0 16.500 9.500 A1.500 1.500 0 1 0 13.500 9.500 Z']],
  StyleOnePinGlobal: ['style-one-pin-global', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm.19,14.818a.249.249,0,0,1-.38,0,6.049,6.049,0,0,1-1.157-2.247.249.249,0,0,1,.239-.321h2.216a.249.249,0,0,1,.2.1.253.253,0,0,1,.04.221A6.048,6.048,0,0,1,12.19,14.818ZM10.542,10.75a.25.25,0,0,1-.249-.229c-.026-.321-.043-.658-.043-1.021s.017-.7.043-1.021a.249.249,0,0,1,.249-.229h2.916a.25.25,0,0,1,.249.229c.026.321.043.658.043,1.021s-.017.7-.043,1.021a.249.249,0,0,1-.249.229ZM6,9.5a5.988,5.988,0,0,1,.093-1.044.25.25,0,0,1,.246-.206h2.2a.252.252,0,0,1,.25.268c-.023.313-.038.637-.038.982s.015.669.038.982a.252.252,0,0,1-.25.268h-2.2a.25.25,0,0,1-.246-.206A5.988,5.988,0,0,1,6,9.5Zm5.809-5.319a.251.251,0,0,1,.38,0,6.03,6.03,0,0,1,1.158,2.248.249.249,0,0,1-.239.321H10.892a.249.249,0,0,1-.2-.1.253.253,0,0,1-.04-.221A6.06,6.06,0,0,1,11.809,4.181Zm3.4,4.337a.252.252,0,0,1,.25-.268h2.2a.25.25,0,0,1,.246.206,5.906,5.906,0,0,1,0,2.088.25.25,0,0,1-.246.206h-2.2a.252.252,0,0,1-.25-.268c.023-.313.038-.637.038-.982S15.235,8.831,15.212,8.518Zm1.9-2.149a.25.25,0,0,1-.214.381H15.169a.25.25,0,0,1-.243-.192A8.813,8.813,0,0,0,14.1,4.363a.251.251,0,0,1,.321-.349A6.044,6.044,0,0,1,17.112,6.369ZM9.575,4.014a.251.251,0,0,1,.321.349,8.813,8.813,0,0,0-.822,2.195.251.251,0,0,1-.243.192H7.1a.251.251,0,0,1-.214-.381A6.044,6.044,0,0,1,9.575,4.014ZM6.888,12.631A.25.25,0,0,1,7.1,12.25H8.831a.25.25,0,0,1,.243.192,8.813,8.813,0,0,0,.822,2.2.25.25,0,0,1-.321.348A6.036,6.036,0,0,1,6.888,12.631Zm7.537,2.354a.25.25,0,0,1-.321-.348,8.813,8.813,0,0,0,.822-2.2.251.251,0,0,1,.243-.192H16.9a.251.251,0,0,1,.214.381A6.036,6.036,0,0,1,14.425,14.985Z']],
  StyleOnePinCircleRemove: ['style-one-pin-circle-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,15.5a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,15.5Z', 'M14.651,6.848a1.248,1.248,0,0,0-1.767,0l-.707.707a.252.252,0,0,1-.354,0l-.707-.707A1.249,1.249,0,1,0,9.349,8.616l.707.707a.251.251,0,0,1,0,.354l-.707.707a1.249,1.249,0,1,0,1.767,1.767l.707-.707a.252.252,0,0,1,.354,0l.707.707a1.249,1.249,0,1,0,1.767-1.767l-.707-.707a.251.251,0,0,1,0-.354l.707-.707A1.249,1.249,0,0,0,14.651,6.848Z']],
  StyleOnePinTarget: ['style-one-pin-target', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.75,9.5a.75.75,0,0,1,.75-.75h.588a.249.249,0,0,0,.2-.1.252.252,0,0,0,.036-.224,3.511,3.511,0,0,0-2.249-2.249.252.252,0,0,0-.224.036.249.249,0,0,0-.1.2V7a.75.75,0,0,1-1.5,0V6.412a.249.249,0,0,0-.1-.2.252.252,0,0,0-.224-.036A3.511,3.511,0,0,0,8.674,8.423a.252.252,0,0,0,.036.224.249.249,0,0,0,.2.1H9.5a.75.75,0,0,1,0,1.5H8.912a.249.249,0,0,0-.2.1.252.252,0,0,0-.036.224,3.511,3.511,0,0,0,2.249,2.249.252.252,0,0,0,.224-.036.249.249,0,0,0,.1-.2V12a.75.75,0,0,1,1.5,0v.588a.249.249,0,0,0,.1.2.252.252,0,0,0,.224.036,3.511,3.511,0,0,0,2.249-2.249.252.252,0,0,0-.036-.224.249.249,0,0,0-.2-.1H14.5A.75.75,0,0,1,13.75,9.5Z', 'M12,0A9.5,9.5,0,0,0,8,18.119a2.509,2.509,0,0,1,1.218,1.222l1.872,4.076a1,1,0,0,0,1.817,0l1.876-4.079A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm7.25,9.5a.75.75,0,0,1-.75.75H17.135a.251.251,0,0,0-.246.2,4.983,4.983,0,0,1-3.937,3.937.25.25,0,0,0-.2.245V16a.75.75,0,0,1-1.5,0V14.634a.25.25,0,0,0-.2-.245,4.983,4.983,0,0,1-3.937-3.937.25.25,0,0,0-.245-.2H5.5a.75.75,0,0,1,0-1.5H6.865a.251.251,0,0,0,.246-.2,4.983,4.983,0,0,1,3.937-3.937.25.25,0,0,0,.2-.245V3a.75.75,0,0,1,1.5,0V4.366a.25.25,0,0,0,.2.245,4.983,4.983,0,0,1,3.937,3.937.25.25,0,0,0,.245.2H18.5A.75.75,0,0,1,19.25,9.5Z']]
};
exports["default"] = _default;